import { $_app_server } from '@/_helpers'

export const dictresultService = {
  //admin actions
  loadList,
  parseFile,
  save,
  del,
  delAll,

  //anonimus actions
  searchResult,
  getsertificat
  
}

//admin actions
function loadList () {
  return $_app_server.get('admin/dictant/loadlist').then(response => response.data)
}

function parseFile (formdata) {
  return $_app_server.post('admin/dictant/parsefile', formdata).then(response => response.data)
}

function save (dictres) {
  return $_app_server.post('admin/dictant/save', dictres).then(response => response.data)
}

function del (id) {
  return $_app_server.delete("admin/dictant/del/" + id)
}

function delAll () {
  return $_app_server.delete("admin/dictant/del/all")
}

//anonimus actions
function searchResult (user) {
  return $_app_server.post('dictant/searchresult', user).then(response => response.data)
}

function getsertificat (user) {
  return $_app_server.post('dictant/getsertificat', user).then(response => response.data)
}
